module.exports = __webpack_public_path__ + "static/media/full_before_after.fec09b60.jpg";